function canonical(value: any): string {
  if (Array.isArray(value)) return '[' + value.map(v => canonical(v ?? null)).join(',') + ']';
  if (value && typeof value === 'object') return '{' + Object.keys(value).sort().filter(k => value[k] !== undefined).map(k => JSON.stringify(k) + ':' + canonical(value[k])).join(',') + '}';
  return JSON.stringify(value);
}
// Only a digest and random ID are stored; customer data and credentials stay out of this journal.
export async function operationJournal(storage: Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>, owner: string, endpoint: string, input: Record<string, any>) {
  const bytes = new TextEncoder().encode(canonical({ owner, endpoint, input }));
  const digest = [...new Uint8Array(await crypto.subtle.digest('SHA-256', bytes))].map(v => v.toString(16).padStart(2, '0')).join('');
  const key = 'apollo-studio:pending-operation:' + digest;
  const stored = storage.getItem(key);
  const id = stored && /^[0-9a-f-]{36}$/i.test(stored) ? stored : crypto.randomUUID();
  storage.setItem(key, id);
  return { id, complete: () => storage.removeItem(key) };
}
